export default __webpack_public_path__ + "static/media/running.8e8e33b9.svg";